import { render, staticRenderFns } from "./Sidebars.vue?vue&type=template&id=46ca7bc6&scoped=true&"
var script = {}
import style0 from "./Sidebars.vue?vue&type=style&index=0&id=46ca7bc6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ca7bc6",
  null
  
)

export default component.exports